<p-overlayPanel
  #opDeadline
  [style]="{ width: '400px' }">
  <ng-template pTemplate="">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Новая дата</label>
        <crm-datepicker
          [disabled]="loading"
          [(value)]="form.deadline"></crm-datepicker>
      </div>

      <div class="field">
        <label class="font-medium required-field">Комментарий</label>
        <crm-editor
          [(value)]="form.commentary"
          [disabled]="loading"
          height="110px"></crm-editor>
      </div>
    </div>

    <button
      pButton
      label="Отправить"
      icon="pi pi-send"
      class="p-button-success"
      [disabled]="!form.deadline || !form.commentary"
      [loading]="loading"
      (click)="sendNewDeadline()"></button>
  </ng-template>
</p-overlayPanel>
